import { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';

import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import RedirectRoute from './RedirectRoute';
import ToolHelper from '../utils/ToolHelper';
import NoMatchPage from '../../screens/NoMatch/NoMatch';

const DeclareRoutes = ({routes,screenProps,routesO}) => (
  <Suspense>
    <Switch>
      {routes.map(({ component: Component, componentByType, path, exact, access = 'public', meta, to, status, allowedTypes = null, notAllowedTypes = null }) => {

        if(componentByType){
          Component = ToolHelper.getOptionByUserType(componentByType)
        }

        let config = {
          path,
          key: path,
          exact,
          routesO,
          allowedTypes,
          notAllowedTypes,
          message: screenProps.message,
          strings: screenProps.config.strings,
        };

        switch(access){
          case 'redirect':
            return <RedirectRoute {...config} to={to} status={status} />

          case 'unlogged':
            return <PublicRoute {...config} onlyUnlogged>
              <Component {...screenProps}/>
            </PublicRoute>

          case 'logged':
            return <PrivateRoute {...config}>
              <Component {...screenProps}/>
            </PrivateRoute>

          case 'public':
          default:
            return <PublicRoute {...config}>
              <Component {...screenProps}/>
            </PublicRoute>
        }
      })}
    </Switch>
  </Suspense>
);

export default DeclareRoutes;
